import React from 'react';

import './_maintenance.scss';

import error404Image from '../../../images/icons/404.png';

const MaintenancePage: React.FC = () => {
  return (
    <div className="maintenance-container">
      <div className="maintenance-inner-container">
        <div className="maintenance-left-container">
          <h1>🏗️ SARAL is under maintenance</h1>
          <div>
            <p>
              The app will be down up to <span style={{ fontWeight: 600 }}>6 am CT on 2nd July</span>
            </p>
          </div>
        </div>
        <div className="maintenance-right-container">
          <img src={error404Image} alt="Error 404" />
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
